import { BrowseSettings } from "@/models/browse-settings";
import { toDateOnlyString } from "./strings";
import { TicketPlannedStatus } from "./ticket-planned-status";

export enum AttentionGiven {
	DISABLED = 0,
	ON = 1,
	ON_AND_UNREAD = 2
}

export class TicketFilters{
	read:boolean|undefined = undefined;
	status:number[] = [];
	assigned:boolean = false;
	departmentIds:number[] = [];
	tierIds:number[] = [];
	searchInput:string = "";
	employeeAccount:boolean | undefined = undefined;
	attention:boolean = false;
	attentionFromAdminIds:number[] = [];
	liked:boolean = false;
	plannedStatus:TicketPlannedStatus = TicketPlannedStatus.None;
	demo:boolean | undefined = undefined;
	free:boolean | undefined = undefined;
	bookmarked:boolean = false;
	companyId:number | undefined = undefined;
	attentionGiven:AttentionGiven = 0;
	timeCreated:Date | undefined = undefined;

	public constructor(data?:any){
		if (!data) return;
		this.read = data.read;
		this.status = data.status;
		this.assigned = data.assigned;
		this.departmentIds = data.departmentIds;
		this.tierIds = data.tierIds;
		this.searchInput = data.searchInputs;
		this.employeeAccount = data.employeeAccount;
		this.attention = data.attention;
		this.attentionFromAdminIds = data.attentionFromAdminIds || [];
		this.liked = data.liked;
		this.plannedStatus = data.plannedStatus;
		this.demo = data.demo;
		this.free = data.free;
		this.bookmarked = data.bookmarked;
		this.companyId = data.companyId;
		this.attentionGiven = data.attentionGiven || 0;
		this.timeCreated = data.timeCreated ? new Date(data.timeCreated) : undefined;
	}

	static fromBrowseSettings(settings:BrowseSettings){
		let filters = new TicketFilters();
		filters.read = settings.getBooleanOrNullValue("read");
		let status = settings.getMetaDataValue("status");
		filters.status = JSON.parse(status || "[]");
		filters.assigned = settings.getBooleanOrNullValue(("assigned")) || false;
		let departmentIds = settings.getMetaDataValue("departmentIds");
		filters.departmentIds = JSON.parse(departmentIds || "[]");
		let tierIds = settings.getMetaDataValue("tierIds");
		filters.tierIds = JSON.parse(tierIds || "[]");
		filters.employeeAccount = settings.getBooleanOrNullValue("employeeAccount");
		filters.demo = settings.getBooleanOrNullValue("demo");
		filters.free = settings.getBooleanOrNullValue("free");
		filters.attention = settings.getBooleanOrNullValue("attention") || false;
		filters.liked = settings.getBooleanOrNullValue("liked") || false;
		filters.attentionFromAdminIds = JSON.parse(settings.getMetaDataValue("attentionFromAdminIds") || "[]");

		let plannedStatusStr = settings.getMetaDataValue("plannedStatus");
		if (plannedStatusStr === undefined) {
			filters.plannedStatus = 0;
		} else {
			filters.plannedStatus = parseInt(plannedStatusStr);
		}
		filters.bookmarked = settings.getBooleanOrNullValue("bookmarked") || false;
		filters.attentionGiven = settings.getNumberValue("attentionGiven");

		let timeCreated = settings.getMetaDataValue("timeCreated");
		if (timeCreated) {
			filters.timeCreated = new Date(timeCreated);
		}
		return filters;
	}

	// eslint-disable-next-line max-lines-per-function
	toUrlQueryParam(multiple:boolean = false):object {
		let result = {
			read: this.read,
			status: multiple ? this.status : JSON.stringify(this.status),
			assigned: this.assigned,
			departmentIds: multiple ? this.departmentIds : JSON.stringify(this.departmentIds),
			tierIds: multiple ? this.tierIds : JSON.stringify(this.tierIds),
			searchInput: this.searchInput,
			attention: this.attention,
			liked: this.liked,
			plannedStatus: this.plannedStatus,
			bookmarked: this.bookmarked,
			companyId: multiple ? this.companyId : JSON.stringify(this.companyId),
			attentionGiven: this.attentionGiven,
			attentionFromAdminIds: multiple ? this.attentionFromAdminIds : JSON.stringify(this.attentionFromAdminIds),
		} as any;
		if (this.employeeAccount === false) {
			result.employeeAccount = "false";
			if (multiple) {
				result.employeeAccount = false;
			}
		}else if (this.employeeAccount == true){
			result.employeeAccount = "true";
			if (multiple) {
				result.employeeAccount = true;
			}
		}
		if (this.demo === false) {
			result.demo = "false";
			if (multiple) {
				result.demo = false;
			}
		}else if (this.demo == true){
			result.demo = "true";
			if (multiple) {
				result.demo = true;
			}
		}
		if (this.free === false){
			result.free = "false";
			if (multiple) {
				result.free = true;
			}
		} else if (this.free == true){
			result.free = "true";
			if (multiple) {
				result.free = true;
			}
		}
		if (this.timeCreated != null){
			result.timeCreated = toDateOnlyString(this.timeCreated);
		}
		return result;
	}

	public toJSON():any{
		return {
			read: this.read,
			status: [...this.status],
			assigned: this.assigned,
			departmentIds: [...this.departmentIds],
			tierIds: [...this.tierIds],
			searchInput: this.searchInput,
			employeeAccount: this.employeeAccount,
			attention: this.attention,
			attentionFromAdminIds: [...this.attentionFromAdminIds],
			liked: this.liked,
			plannedStatus: this.plannedStatus,
			demo: this.demo,
			free: this.free,
			bookmarked: this.bookmarked,
			companyId: this.companyId,
			attentionGiven: this.attentionGiven,
			timeCreated: this.timeCreated ? toDateOnlyString(this.timeCreated) : undefined
		};
	}
}
